import { getStaticUrl } from '~/utils/static'

export function useStatic() {
  return getStaticUrl
}
